:host {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 0 calc(var(--spacer) - 2px) 0 calc(var(--spacer) * 2);
}

.message {
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
}

.group-buttons > * {
  padding-top: var(--spacer);
}
